export default __webpack_public_path__ + "static/media/393.f29dddf1.png";